var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.725V18.675C15.5 18.2417 16.7083 17.4083 17.625 16.175C18.5417 14.9417 19 13.5417 19 11.975C19 10.4083 18.5417 9.00834 17.625 7.77501C16.7083 6.54167 15.5 5.70834 14 5.27501V3.22501C16.0667 3.69167 17.75 4.73751 19.05 6.36251C20.35 7.98751 21 9.85834 21 11.975C21 14.0917 20.35 15.9625 19.05 17.5875C17.75 19.2125 16.0667 20.2583 14 20.725ZM3 15V9.00001H7L12 4.00001V20L7 15H3ZM14 16V7.95001C14.7833 8.31667 15.3958 8.86667 15.8375 9.60001C16.2792 10.3333 16.5 11.1333 16.5 12C16.5 12.85 16.2792 13.6375 15.8375 14.3625C15.3958 15.0875 14.7833 15.6333 14 16Z",
    fill: "#BCB9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuteIcon);
export default __webpack_public_path__ + "static/media/unmute-icon.312c47555776fead637ac4a68a9c2f43.svg";
export { ForwardRef as ReactComponent };